import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button, Row } from "reactstrap";
import moment from "moment";

//Context
import { useAuth } from "../../../context/auth";

// Components
import MainCard from "../../../components/MainCard/MainCard";
import TabelaListagemFichas from "../../../components/TabelaListagemFichas/TabelaListagemFichas";
import mascaras from "../../../helpers/mascaras";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";

export default function RelatorioGeradoresSemContratoEPendente({
  dadosRelatorio,
  btnVoltar,
  filtros,
}) {
  const { setupVariavel, session } = useAuth();
  const refRelatorio = useRef();
  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  const headersTabela = [
    { value: "Fantasia", objectValue: "fantasia", align: "left" },
    { value: "Razão Social", objectValue: "razao", align: "left" },
    { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
    { value: "Status", objectValue: "status", align: "left" },
    { value: "Categoria", objectValue: "categoria", align: "left" },
    { value: "Ramo de Atividade", objectValue: "ramoDeAtividade", align: "left" },
    { value: "Modalidade de Coleta", objectValue: "modalidadeColeta", align: "left" },
    { value: "Transportador", objectValue: "transportador", align: "left" },
    { value: "Validade do Cadastro", objectValue: "validadeCadastro", align: "left" },
    { value: "Data do Cadastro", objectValue: "dataCadastroFormatada", align: "left" },
    { value: "Motivo", objectValue: "motivoContratoPendente", align: "left" },
    { value: "Situação", objectValue: "situacaoContrato", align: "left" },
    { value: "CNAE", objectValue: "cnaes", align: "left" },
  ];

  const headersExport = [
    { key: "fantasia", label: "FANTASIA" },
    { key: "razao", label: "RAZÃO SOCIAL" },
    { key: "cpfcnpj", label: "CPF/CNPJ" },
    { key: "status", label: "STATUS" },
    { key: "categoria", label: "CATEGORIA" },
    { key: "ramoDeAtividade", label: "RAMO DE ATIVIDADE" },
    { key: "modalidadeColeta", label: "MODALIDADE DE COLETA" },
    { key: "transportador", label: "TRANSPORTADOR" },
    { key: "validadeCadastro", label: "VALIDADE DO CADASTRO" },
    { key: "dataCadastroFormatada", label: "DATA DO CADASTRO" },
    { key: "motivoContratoPendente", label: "MOTIVO" },
    { key: "situacaoContrato", label: "SITUAÇÃO" },
    { key: "cnaes", label: "CNAE" },
  ];

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: "Relatório de Geradores Sem Contrato E Pendente",
  });

  //Botão de exportação csv
  const BtnExportCsv = () => {
    return (
        <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
            <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
        </Button>
    )
  }

  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
    <CSVLink 
      separator={";"} 
      data={dadosRelatorio?.map((value) => {
        value.cpfcnpj = !!value.cpfcnpj
          ? mascaras.cpfcnpjMask(value.cpfcnpj)
          : value.cpfcnpj;
        value.dataCadastroFormatada = value.dataHoraCadastro
          ? moment(value.dataHoraCadastro).format("DD/MM/YYYY")
          : "";
        value.cnaes = Array.isArray(value.cnaes)
          ? value.cnaes.map((c) => c.codigo + (c.principal ? " (Principal)" : "")).join(", ")
          : value.cnaes;
        return value;
      }) || []}
      headers={headersExport} 
      filename="Relatorio de geradores sem contrato e pendente.csv" 
      target="_blank"
      ref={exportRef}
    >
     </CSVLink>
      
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session?.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>
        {setupVariavel?.logoTipo && (
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={"data:image/png;base64," + setupVariavel?.logoTipo}
              width={250}
              alt="Logo"
            />
          </div>
        )}
        <div className="header">
          <h4 className="text-black">
            Relatório de Geradores Sem Contrato E Pendente
          </h4>
          {filtros && (
            <div style={{ fontSize: "14px", color: "#555" }}>
              <strong>Situação:</strong> {filtros.situacao} | 
              <strong> CNPJ:</strong> {filtros.cnpj || "Todos"} | 
              <strong> Razão/Fantasia:</strong> {filtros.razao || "Todos"} | 
              <strong> Transportador:</strong> {filtros.transportadorNome || "Todos"}
            </div>
          )}
        </div>
        <div className="body">
          <h5 className="mt-4 rounded-3 bg-secondary text-light p-2">
            Lista de geradores
          </h5>
          <Row>
            <TabelaListagemFichas
              headers={headersTabela}
              items={
                dadosRelatorio?.map((value) => {
                  value.cpfcnpj = !!value.cpfcnpj
                    ? mascaras.cpfcnpjMask(value.cpfcnpj)
                    : value.cpfcnpj;
                  value.dataCadastroFormatada = value.dataHoraCadastro
                    ? moment(value.dataHoraCadastro).format("DD/MM/YYYY")
                    : "";
                  value.cnaes = Array.isArray(value.cnaes)
                    ? value.cnaes.map((c) => c.codigo + (c.principal ? " (Principal)" : "")).join(", ")
                    : value.cnaes;
                  return value;
                }) || []
              }
              scrollbar={false}
            />
          </Row>
        </div>
      </div>
    </MainCard>
  );
}
